
import { useState } from "react";
import { Typography, Card, Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useNavigate, useParams } from "react-router-dom";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import api from "../../../../services/api";
import * as yup from 'yup'; // VALIDACAO
import RegisterAccess from "../../../../utils/registerAccess";
import ButtonLeft from "../../../../utils/buttonLeft";


export default function ChangeStatusDesalfandegamento({ solicitacaoImportacao, setRefresh, setAction }) {
    const { id } = useParams()
    const { action } = useParams()
    const { status } = useParams()
    const navigate = useNavigate()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    // const baseUrl = window.location.origin;
    const dispatch = useDispatch()


    const handleChangeStatus = () => {
        setOpen(true)
        api.patch('/declaracao-desalfandegamento/change-status', {
            status: status,
            // status: 'Reprovado',
            declaracaoDesalfandegamentoId: solicitacaoImportacao.declaracao._id,
            userId: user?._id
        }).then(response => {
            obs && HandleCreateobservacao("Desalfandegamento");
            setRefresh(response.data)
            dispatch({
                type: 'alert',
                payload: { alert: 'Solicitação encaminhada com sucesso.!' },
            });

            // navigate(-1)
            // navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}`)
            navigate(localStorage.getItem('urlAnterior') || -1);
            // console.log(response)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setOpen(false))
    }

    async function HandleCreateobservacao(assunto) {
        setOpen(true)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', {
            assunto: assunto,
            descricao: obs,
            userId: user._id,
            estabelecimentoId: solicitacaoImportacao.importador._id
        }).then(res => {
            setOpen(false)
            setMessageSuccess(res.data.msg)

        }).catch(error => {
            setMessageError(error.response.data.message)
            setOpen(false)
        })
    }

    async function validate() {
        setMessageError('');

        let schema = yup.object().shape({
            observacao: yup.string("Necessário inserir as observações").required("Necessário inserir observações"),
        })

        try {
            await schema.validate({ 'observacao': obs })
            handleChangeStatus()
        } catch (error) {
            setMessageError(error.errors);
        }
        return false
    }


    return (
        <Card style={{ padding: 20, paddingBottom: 30 }}>
            <RegisterAccess page={'alteração de estado de solicitacao de importação'} />
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <div style={{ marginBottom: 30 }}>
                <Typography style={{ lineHeight: 1.5 }} variant="h5">
                    Confirmação de
                    {action === 'approve' ? ' aprovação' : ' reprovação'}
                </Typography>

                <Divider />

                {action === 'approve' &&
                    <Typography >
                        Ao comfirmar esta ação estarás a afirmar que análisaste correctamente
                        toda informação e documentos anexado neste processo estão em conformidade!
                    </Typography>
                }

                <FazerObservacoes setObs={setObs} obs={obs} titulo={action === 'approve' ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação)'} />

                <ButtonLeft
                    title={'Confirmar'}
                    load={open}
                    disabled={open}
                    funcao={action === 'approve' ? handleChangeStatus : validate}
                >
                    <Button color="error" onClick={() => navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}`)} >Cancelar</Button>
                </ButtonLeft>
            </div>
        </Card>
    )
}